import { useMemo } from 'react';
import useSWR from "swr";

// utils
import { fetcher, endpoints, poster, patcher } from '../utils/axios';

export async function getAllReports(payload){
    const URL = endpoints.reports.list
    return await fetcher([URL, {params:payload}] )
}

export async function updateReportStatus(payload) {
    const URL = endpoints.interpretation.requestInterpretation;
    return await poster([URL,payload])
}
export async function revokeInterpretationRequest(payload) {
    const URL = endpoints.interpretation.revokeInterpretationRequest;
    return await poster([URL,payload])
}
//Old
export async function getEcgData(param, payload) {
    const URL = endpoints.data.getEcgData
    return await fetcher([ URL+`${param}`, { params: payload }])
}
//New With SWR Hook
export function useGetEcgData(args = {}, path = '') {
    const URL = [`${endpoints.data.getEcgData}${path}`, { params: args }];
    const { data, error, isLoading, isValidating } = useSWR(URL, fetcher);
    const memoizedValue = useMemo(() => ({
        ecgData: data?.data || null,
        isLoading,
        error,
        isValidating,
    }), [data, error, isLoading, isValidating]);
    return memoizedValue;
}


export async function getEcgReportAndData(payload) {
    const URL = endpoints.data.getEcgReportAndData
    return await fetcher([ URL+`${payload.id}`])
}
export async function saveDataInterpretation(payload) {
    const URL = endpoints.interpretation.saveDataInterpretation;
    return await patcher([ URL,payload.bodyData])
}
// export async function getB2Busers(payload) {
//     const URL = endpoints.loginProcess.getB2Busers
//     //Path Params 
//     return await fetcher([URL+`${""}`])
// }
export async function getSpecificInvoiceData(payload){
    const URL = endpoints.data.getSpecificInvoiceData
    return await fetcher([URL, { params: payload }])
}

export async function downloadLeadFile(payload, config) {
    const URL = endpoints.data.downloadLeadFile;
    return await fetcher([URL, { params: payload, ...(config || {}) }])
}

export async function careLogAiInterpretation(payload) {
    const URL = endpoints.interpretation.careLogAiInterpretation;
    return await fetcher([URL, { params: payload }])
}
export async function spandanAiDetails(payload) {
    const URL = endpoints.interpretation.spandanAiDetails;
    return await fetcher([URL, { params: payload }])
}

export async function getCenterDetails(param, payload) {
    const URL = endpoints.center
    return await fetcher( [URL,  payload] )
}

export async function getPrescription(param, payload) {
    const URL = endpoints.interpretation.getPrescription;
    return await fetcher([ URL+`${param}`, { params: payload }])
}

export async function getReportInterpretaionStatus(param, payload) {
    const URL = endpoints.reports.getInterpretationStatus;
    return await fetcher([ URL+`${param}`, { params: payload }])
}

export async function LeadTraceMatrix(payload) {
  const URL = endpoints.interpretation.LeadTraceMatrix;
  return await poster([URL, payload]);
}
//Old
export async function CollectionsData(param, payload) {
    const URL = endpoints.interpretation.reportData;
    return await fetcher([ URL+`${param}`, { params: payload }])
}
//New SWR Hook
export function useCollectionsData(param, payload = {}) {
    const URL = param
      ? [`${endpoints.interpretation.reportData}${param}`, { params: payload }]
      : null;
  
    const { data, error, isLoading, isValidating } = useSWR(URL, fetcher);
  
    const memoizedValue = useMemo(
      () => ({
        collectionData: data?.data || null,
        isLoading,
        error,
        isValidating,
      }),
      [data, error, isLoading, isValidating]
    );
  
    return memoizedValue;
  }

export async function getAllReplicas(payload){
    const URL = endpoints.reports.getlistreplica
    return await fetcher([URL, {params:payload}] )
}

export async function saveInterpretationReplica(payload) {
    const URL = endpoints.interpretation.saveDataInterpretationReplica;
    return await patcher([ URL,payload.bodyData])
}
//Old
export async function getReplicaInterpretationData({ id, replicadata, ...payload }) {
  const URL = endpoints.data.getEcgData;
  return await fetcher([
    `${URL}${id}`,
    { params: { replicadata, ...payload } }
  ]);
}
//New
export function useGetReplicaInterpretationData(args) {
    const id = args?.id;
    const replicadata = args?.replicadata;
  
    const shouldFetch = !!id;
  
    const URL = shouldFetch
      ? [
          `${endpoints.data.getEcgData}${args.id}`,
          {
          params: {
            replicadata: args?.replicadata   // ✅ only this
          }
        }
        ]
      : null;
  
    const { data, error, isLoading, isValidating } = useSWR(URL, fetcher);
  
    const memoizedValue = useMemo(
      () => ({
        replicaInterpretationData: data?.data || null,
        isLoading,
        error,
        isValidating,
      }),
      [data, error, isLoading, isValidating]
    );
  
    return memoizedValue;
  }

export async function revokeReplicaInterpretationRequest(payload) {
    const URL = endpoints.interpretation.revokeInterpretationRequest;
    return await poster(URL,payload,true)
}

// export async function downloadPrescription(id) {
//     const URL = endpoints.reports.downloadPrescription;
//     return await fetcher([`${URL}${id}`]);
// }

export async function downloadReportOrPrescription(param, payload) {
    
    const URL = endpoints.reports.downloadReportOrPrescription;
    // return await fetcher([`${URL}${id}`]);
    return await fetcher([ URL+`${param}`, { params: payload }])
}

export function useGetEcgGraph(args = {}, path = '') {
    const URL = [`${endpoints.reports.getEcgGraph}/${path}`, { params: args }];
    const { data, error, isLoading, isValidating } = useSWR(URL, fetcher);
    const memoizedValue = useMemo(() => ({
        ecgGraph: data?.data || null,
        isLoading,
        error,
        isValidating,
    }), [data, error, isLoading, isValidating]);
    return memoizedValue;
}

